import { RoleHierarchy } from '../../../../../shared/src/data/roleHierarchy/roleHierarchy'

export const scanMetadataKeyFactory = {
  all: ['scanMetadata'] as const,
  scansForRoleHierarchy: (roleHierarchy?: RoleHierarchy) => [
    ...scanMetadataKeyFactory.all,
    'scansForRoleHierarchy',
    roleHierarchy?.organization.id,
    roleHierarchy?.branch.name,
  ],
  filesRelatedToScan: (uploadId?: string) => [
    ...scanMetadataKeyFactory.all,
    'filesRelatedToScan',
    uploadId,
  ],
}
